import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const BriefCaseIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3335 6.41663H3.66683C2.65431 6.41663 1.8335 7.23744 1.8335 8.24996V17.4166C1.8335 18.4291 2.65431 19.25 3.66683 19.25H18.3335C19.346 19.25 20.1668 18.4291 20.1668 17.4166V8.24996C20.1668 7.23744 19.346 6.41663 18.3335 6.41663Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6668 19.25V4.58333C14.6668 4.0971 14.4737 3.63079 14.1299 3.28697C13.786 2.94315 13.3197 2.75 12.8335 2.75H9.16683C8.6806 2.75 8.21428 2.94315 7.87047 3.28697C7.52665 3.63079 7.3335 4.0971 7.3335 4.58333V19.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
